import { useQuery } from '@tanstack/react-query';
import apiClient from '../utils/apiClient';

interface SatisfactionAverageData {
  average12Months: number;
  lastMonthValue: number;
  trend: 'better' | 'worse' | 'stable';
  trendPercentage: number;
}

export const useSatisfactionAverage = (branchId: number) => {
  return useQuery<SatisfactionAverageData>({
    queryKey: ['satisfactionAverage', branchId],
    queryFn: async () => {
      const response = await apiClient.get(`/main-performance/${branchId}/satisfaction-average`);
      
      if (response.data && response.data.success) {
        return response.data.data;
      } else {
        throw new Error('Failed to fetch satisfaction average');
      }
    },
    staleTime: 5 * 60 * 1000, // 5 minutes
    gcTime: 10 * 60 * 1000, // 10 minutes
    retry: 2,
    retryDelay: attemptIndex => Math.min(1000 * 2 ** attemptIndex, 30000),
  });
};